<template>
  <div v-if="status"
       :class="bannerClasses"
       v-html="bannerContent"/>
</template>

<script>
  import { kebabCase } from 'lodash'

  export default {
    name: 'ProductSaleBanner',
    props: {
      isOnSale: {
        type: Boolean,
        default: false
      },
      isDailyDeal: {
        type: Boolean,
        default: false
      },
      isInStock: {
        type: Boolean,
        default: false
      },
      isBestSeller: {
        type: Boolean,
        default: false
      },
      size: {
        type: String,
        default: 'normal',
        validate (size) {
          return ['normal', 'small'].includes(size)
        }
      }
    },
    computed: {
      status () {
        if (this.isBestSeller) return 'BestSeller'
        if (this.isOnSale && this.isDailyDeal && this.isInStock) return 'DailyDeal'
        if (this.isOnSale && this.isDailyDeal) return 'DailyDealSoldOut'
        if (this.isOnSale) return 'OnSale'

        return null
      },
      bannerContent () {
        switch (this.status) {
          case 'BestSeller':
            return 'Best Seller'
          case 'DailyDeal':
            return 'Daily Deal'
          case 'DailyDealSoldOut':
            return `<span ${this.$options._scopeId} class="product-sale-banner__crossed-out">DAILY DEAL</span> SOLD OUT`
          case 'OnSale':
            return 'Sale'
          default:
            return ''
        }
      },
      bannerClasses () {
        return [
          'product-sale-banner',
          `product-sale-banner--${this.size}`,
          `product-sale-banner--${kebabCase(this.status)}`
        ]
      }
    }
  }
</script>

<style scoped lang="scss">
  @import '@/assets/stylesheets/variables';

  .product-sale-banner {
    background: $color-sale;
    color: $color-white;
    font-family: 'OpenSans SemiBold';
    font-size: 1.6rem;
    padding: 5px 20px;
    text-transform: uppercase;

    &--small {
      font-size: 14px;
      font-weight: 100;
      line-height: 1.36;
      letter-spacing: 0.7px;
      width: 65px;
      height: 65px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      box-sizing: border-box;
      background: $venetian-red;
      text-align: center;

      &.product-sale-banner--best-seller {
        font-size: 1.2rem;
      }
    }

    &--best-seller {
      background: $gunmetal;
    }

    &--daily-deal {
      background-color: $ateneo-blue;

      &-sold-out {
        font-family: 'MotivaSans SemiBold';
        background: $medium-gray;
      }
    }

    &__crossed-out {
      text-decoration: line-through;
    }
  }
</style>